import React from 'react'
import { getColorByFacilityType } from '../../../../../utils/chart/palette'

const WrappedTick = ({ x, y, text, style, maxWidth = 60, facilityTypes }) => {
    const ft = facilityTypes.find(x => x.FacilityTypeDisplay === text)
    const color = getColorByFacilityType(ft && ft.FacilityType)

    return (
        ft ? (
            <foreignObject
                x={x - maxWidth / 2}
                y={y - 10}
                width={maxWidth}
                height={60}
            >
                <div
                    style={{
                        width: maxWidth,
                        wordWrap: 'break-word',
                        textAlign: 'center',
                    }}
                    xmlns="http://www.w3.org/1999/xhtml"
                >
                    <span
                        style={{
                            ...style,
                            color:
                                color.fill === 'white'
                                    ? color.stroke
                                    : color.fill,
                            padding: 0,
                        }}
                    >
                        {text}
                    </span>
                </div>
            </foreignObject>
        ) : ''
    )
}

export default WrappedTick
